import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      ...theme.typography.button,
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: '20px',
      textAlign: 'center',
      color: theme.palette.common.black,
      textTransform: 'none',
      minHeight: '2.5rem',
      padding: '1rem 0.5rem',
      '& svg': {
          marginRight: '0.25rem'
      },
      '&:hover': {
        color: theme.palette.primary.dark,
      },
      '&:focus': {
        color: theme.palette.primary.dark,
        backgroundColor: 'rgba(44, 148, 167, 0.1)',
        borderRadius: '4px',
        border: '3px solid rgba(44, 148, 167, 0.4)',
      },
    },
    underline: {
      textDecoration: 'underline',
      textDecorationThickness: '2px',
      textUnderlinePosition: 'under',
      textDecorationColor: theme.palette.utility.linkSecondaryUnderlineEnabled,

      '&:hover': {
        cursor: 'pointer',
        textDecorationThickness: '2px',
        textDecorationColor: theme.palette.primary.dark,
      },
      '&:focus': {
        textDecorationThickness: '2px',
        textDecorationColor: theme.palette.primary.dark,
      },
    },
    disabled: {
      ...theme.typography.button,
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: '20px',
      textAlign: 'center',
      textTransform: 'none',
      color: theme.palette.utility.linkDisabledText,
      borderBottom: `2px solid ${theme.palette.utility.linkDisabledUnderline}`,
      paddingBottom: '2px',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  }),
  { index: 1 },
);
